import DashboardLayout from "@/layouts/dashboard-layout";
import "./styles.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { Activity } from "@/types/activity";
import { useAuth } from "@/contexts/auth-context";
import { activityLessonFetch } from "@/redux/slice/activity/lessons";
import { Padlock } from "../level-icon/Level-Icons-unzipped";
import { useLanguageContext } from "@/contexts/language-context";

export const Lessons = () => {
  const { level_id } = useParams();
  const { token, updateActivityValues, activityValue } = useAuth();
  const location = useLocation();
  const state = location.state as { title: string };
  const dispatch = useAppDispatch();
  const { values } = useLanguageContext();
  const { data, error, loading } = useAppSelector(
    (state) => state.activityLesson
  );

  useEffect(() => {
    if (token && level_id) {
      dispatch(
        activityLessonFetch({
          token,
          level_id,
          language: values.initialLanguage,
        })
      );
    }
  }, [dispatch, token, level_id, values.initialLanguage]);

  return (
    <DashboardLayout>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <h3 className="package-header-title">{state?.title}</h3>

          {data && data.length > 0 ? (
            data.map((item: Activity) =>
              item.locked ? (
                <button
                  className="package-card-container"
                  disabled
                  style={{
                    alignItems: "flex-start",
                    display: "flex",
                    backgroundColor: "#e1e8ed",
                    justifyContent: "space-between",
                  }}
                >
                  {item.title}
                  <Padlock />
                </button>
              ) : (
                <Link
                  className="package-card-container"
                  to={`/activity/level/${level_id}/lesson/${item.id}/brief`}
                  onClick={() =>
                    updateActivityValues({
                      ...activityValue,
                      lessonId: item.id,
                      summary: item.points,
                    })
                  }
                >
                  <h3 className="package-title">{item.title}</h3>
                </Link>
              )
            )
          ) : (
            <p>No lessons found.</p>
          )}
        </div>
      )}
    </DashboardLayout>
  );
};
